import { Link as MuiLink } from '@mui/material';
import { Link as GatsbyLink } from 'gatsby';
import * as React from 'react';

const isValidUrl = (string) => {
	// Validate the string format against any valid protocol/scheme (such as https:, http:, ftp:, or mailto:)
	try {
		new URL(string);
		return true;
	} catch (err) {
		return false;
	}
}


const isValidRelativeUrl = (urlString) => {

	// Exclude absolute URLs (those with protocols like http://, https://, ftp://, etc.)
	if (/^[a-z0-9+.-]+:\/\//i.test(urlString)) {
		return false;
	}

	// Validate using a dummy base URL
	return URL.canParse(urlString, "https://example.com");
}

export const formatToHttps = (input) => {
	if (!input) return "";
	// Trim whitespace
	const str = input.trim();

	// Regular expression to validate a basic domain name structure (e.g., example.com, www.sub.domain.org)
	// This matches optional http/https protocols followed by a valid domain and top-level domain (TLD)
	const domainRegex = /^(((http|https):\/\/|)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?)$/;

	// If it's not a valid domain structure, check for fully qualified urls and relative urls
	if (!domainRegex.test(str)) {
		if (str.startsWith('www.') && URL.canParse(str, "https://example.com")) {
			return `https://${str}`;
		}
		if (isValidUrl(str)) {
			return str;
		}
		if (isValidRelativeUrl(str)) {
			if (str.startsWith("/")) {
				return str;
			}
		}
		return "Invalid domain"; 
	}

	// Check if it already starts with https://
	if (str.startsWith("https://")) {
		return str;
	}

	// If it starts with http:// instead, swap it to https://
	if (str.startsWith("http://")) {
		return str.replace("http://", "https://");
	}

	// Otherwise, it's a domain missing the protocol entirely. Prepends https://
	return `https://${str}`;
}

const Link = React.forwardRef(function Link(
	props,
	ref
) {
	let {
		href,
		to,
		external,
		component,
		children,
		text,
		...rest
	} = props;
	if (to !== undefined && href === undefined) href = to;
	const internalHostPattern =
		/^(?:https?:\/\/)?(?:(?:www\.)?visitsouthwalton\.com|visitsouthwalton-2025\.stage\.zehndev\.com|visitsouthwalton\.stage\.zehndev\.com)(?=\/|[?#]|$)/i;

	if (href) {
		href = href.replace(internalHostPattern, '');
		href = formatToHttps(href);
	}

	const isExternal =
		typeof external === 'boolean'
			? external
			: href === undefined || href.startsWith('#') || href.startsWith('/userfiles/') || /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(href);

	const content = children || text;

	if (isExternal) {
		if (rest.target === undefined)rest.target = '_blank';
		rest.rel = 'noopener noreferrer';
		return (
			<MuiLink ref={ref} href={href || to} {...rest}>
				{content}
			</MuiLink>
		);
	}

	const InternalComponent = component || GatsbyLink;
	return (
		<MuiLink component={InternalComponent}
			ref={ref}
			to={to || href}
			{...rest}
		>
			{content}
		</MuiLink>
	);
});

export default Link;
